// extracted by mini-css-extract-plugin
export default {"root":"HBWxfk","chained":"CKY_VJ","header":"rllim2","content":"kyf80j","own":"s8ajxz","pending":"JNwgo1","avatar":"viGUSZ","name":"tmFYLg","timeAgo":"FU_eJn"};